import { AxiosResponse } from 'axios';
import Apis from '../apis';

export type ApplicationInfo = { uuid: string; nome: string };
export type ScopeInfo = { scope: string; app: { nome: string; descricao: string }; permissao: { descricao: string } };

interface OauthDataSourceI {
  // Coleta informações da aplicação
  aplicacaoInfo(aplicacaoUuid: string): Promise<AxiosResponse<ApplicationInfo>>;
  // Coleta informações dos escopos solicitados
  scopeInfo(scope: string): Promise<AxiosResponse<ScopeInfo[]>>;
}

export class OauthDataSource implements OauthDataSourceI {
  async aplicacaoInfo(aplicacaoUuid: string): Promise<AxiosResponse<ApplicationInfo>> {
    return await Apis.ApiAuth.get('aplicacao/info', {
      params: {
        uuid: aplicacaoUuid,
      },
    });
  }
  async scopeInfo(scope: string): Promise<AxiosResponse<ScopeInfo[]>> {
    return await Apis.ApiAuth.get('scope/info', {
      params: {
        scope,
      },
    });
  }
}
